var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, action } from 'mobx';
import { api } from 'helpers/Api';
export default class default_1 {
    get result() {
        return this.resultSalesReport;
    }
    salesReport(range) {
        console.log('DashboardTicketStore - salesReport');
        if (range) {
            return api.get(`/tickets/totalsale/${range}`).then(totalSales => {
                console.log('DashboardTicketStore - totalSales: ', totalSales);
                return this.setResult(totalSales);
            });
        }
        return api.get(`/tickets/totalsale`).then(totalSales => {
            console.log('DashboardTicketStore - totalSales: ', totalSales);
            return this.setResult(totalSales);
        });
    }
    customerReport(range) {
        return api.get(`/tickets/salescustomers/${range}`).then(totals => totals);
    }
    setResult(result) {
        this.resultSalesReport = result;
        return this.resultSalesReport;
    }
}
__decorate([
    observable
], default_1.prototype, "resultSalesReport", void 0);
__decorate([
    computed
], default_1.prototype, "result", null);
__decorate([
    action
], default_1.prototype, "setResult", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/Store.ts
// module id = 350
// module chunks = 0